export default __webpack_public_path__ + "static/media/PowerShell-Upgrade-WindowsServer.ed294b3b.png";